import React from 'react';
import { observer } from 'mobx-react';
import FileRepositoryCategoryModal from './FileRepositoryCategoryModal';
import FileRepositoryCategoryService from '../services/FileRepositoryCategoryService';

class FileRepositoryCategoryModalContainer extends React.Component {
  render() {
    return (
      <FileRepositoryCategoryModal
        onClose={FileRepositoryCategoryService.handleToggleCategoryModal}
        isModalOpen={FileRepositoryCategoryService.isModalOpen}
        isEditing={FileRepositoryCategoryService.isEditing}
        onChange={FileRepositoryCategoryService.form.setValue}
        values={FileRepositoryCategoryService.form.getValues()}
        errors={FileRepositoryCategoryService.form.errors}
        loading={FileRepositoryCategoryService.fetch.fetching}
        submitting={FileRepositoryCategoryService.fetch.fetching}
        disabled={FileRepositoryCategoryService.fetch.fetching}
        onSubmit={FileRepositoryCategoryService.handleCategorySubmit}
        onReset={FileRepositoryCategoryService.handleResetCategoryModal}
      />
    );
  }
}

export default observer(FileRepositoryCategoryModalContainer);
